import React from "react";

function FrameSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="260"
      height="329"
      viewBox="0 0 260 329"
      fill="none"
    >
      <path
        d="M30.6273 14.3613H127.531H228.068L246.843 28.996V292.753L228.068 309.716H30.6273L15.1833 292.753V28.996L30.6273 14.3613Z"
        fill="#111111"
        stroke="#414141"
        strokeWidth="2"
      />
      <path d="M209.696 1H229.631L258.325 24.2513V60.071" stroke="#414141" />
      <path d="M49.6282 1H29.6936L0.999905 24.2513V60.071" stroke="#414141" />
      <path d="M210.372 328H230.306L259 301.581V265.413" stroke="#414141" />
      <path d="M47.6021 328H27.5281L1.67535 300.073V266.116" stroke="#414141" />
    </svg>
  );
}

export default FrameSVG;
